import { useEffect, useState, type FormEvent } from 'react';
import { api, ApiError, session } from '../api';
import { ErrorBox } from '../components/Layout';

export function LoginPage({ appName, onSignedIn }: { appName: string; onSignedIn: () => void }) {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    document.title = `ເຂົ້າສູ່ລະບົບ | ${appName}`;
  }, [appName]);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setBusy(true);
    setError(null);
    try {
      const { token } = await api.login(
        String(form.get('username') ?? ''),
        String(form.get('password') ?? ''),
      );
      session.set(token);
      onSignedIn();
    } catch (err: unknown) {
      setError(err instanceof ApiError ? err.message : 'ເຂົ້າສູ່ລະບົບບໍ່ສຳເລັດ');
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <div className="login-shell">
        <aside className="login-illustration">
          <div className="login-illustration-glow" />
          <img src="/logo-icon.svg" alt="" className="login-illustration-logo" width={72} height={72} />
          <h2 className="login-illustration-title">{appName}</h2>
          <p className="login-illustration-tagline">
            ຮັບຊຳລະເງິນຜ່ານ Lao QR ເຂົ້າບັນຊີ BCEL One ໂດຍກົງ — ວ່ອງໄວ ແລະ ປອດໄພ
          </p>
        </aside>

        <section className="login-panel">
          <form className="login-card" onSubmit={submit}>
            <div className="login-brand">
              <img src="/logo-icon.svg" alt="" className="login-logo login-logo-mobile" width={44} height={44} />
              <h1 className="login-brand-name">ເຂົ້າສູ່ລະບົບ</h1>
              <p className="login-brand-sub">ໃສ່ຊື່ຜູ້ໃຊ້ ແລະ ລະຫັດຜ່ານຂອງທ່ານ</p>
            </div>

            <ErrorBox error={error} />

            <label>
              ຊື່ຜູ້ໃຊ້
              <input name="username" autoComplete="username" autoFocus required />
            </label>
            <label>
              ລະຫັດຜ່ານ
              <span className="login-password-field">
                <input
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'ເຊື່ອງລະຫັດຜ່ານ' : 'ສະແດງລະຫັດຜ່ານ'}
                >
                  {showPassword ? 'ເຊື່ອງ' : 'ສະແດງ'}
                </button>
              </span>
            </label>
            <button type="submit" className="login-submit" disabled={busy}>
              {busy ? 'ກຳລັງເຂົ້າ…' : 'ເຂົ້າສູ່ລະບົບ'}
            </button>
          </form>
        </section>
      </div>
    </main>
  );
}
